<app-ui-status-pill
  [icon]="pillParams().icon"
  [label]="languageService.getTranslationTyped(pillParams().label)"
  [color]="pillParams().color"
>
</app-ui-status-pill>
